module.exports = __webpack_public_path__ + "assets/img/TMSP1-2.bee010c3.jpg";